
  <template><svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" fill="none" viewBox="0 0 18 16"><path fill="#475361" d="M16.955 13.154a.38.38 0 0 1 .076.559l-.483.635a.436.436 0 0 1-.584.076L1.034 2.87c-.177-.127-.203-.38-.076-.558l.508-.635a.38.38 0 0 1 .559-.076l3.758 2.894A3.22 3.22 0 0 1 9.007 1.5c1.778 0 3.25 1.473 3.25 3.25 0 1.422-.914 2.615-2.183 3.072zM3.32 12.24a3.39 3.39 0 0 1 2.818-3.35l7.287 5.611H4.54a1.203 1.203 0 0 1-1.22-1.219z"/></svg></template>
  <style scoped>
    svg {
      display: inline-block;
      vertical-align: baseline;
      margin-bottom: -2px;
    }
  </style>